<template>
  <!-- <div>
    <li>{{ hotSay.content }}</li>
  </div> -->
  <dl>
    <dt>
      <img :src="hotSay.user.avatarUrl" alt="" />
    </dt>
    <dd>
      <span class="firname">{{ hotSay.user.nickname }} &nbsp;:&nbsp;</span>
      <span class="des">{{ hotSay.content }}</span>
      <h6 class="times">评论时间：{{ timeChange(hotSay.time) }}</h6>
    </dd>
  </dl>
</template>

<script>
export default {
  props: ["hotSay"],
  methods: {
    // 时间转换
    timeChange(n) {
      var now = new Date(n);
      var year = now.getFullYear(n);
      var month = now.getMonth(n) + 1;
      var day = now.getDate(n);
      var hour = now.getHours(n);
      var min = now.getMinutes(n);
      return year + "年" + month + "月" + day + "日" + hour + ":" + min;
    }
  }
};
</script>

<style lang="less" scoped>
dl {
  padding: 10px;
  overflow: hidden;
  border-top: 1px dotted #ccc;
  display: flex;
  flex-direction: row;
  dt {
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
  dd {
    width: 260px;
    float: left;
    // line-height: 50px;
    margin-left: 10px;
    font-size: 12px;
    .firname {
      display: inline-block;
      padding-right: 2px;
      color: #0c73c2;
    }
    .des {
      color: #333;
      line-height: 25px;
    }
    .times {
      color: #333;
      line-height: 25px;
    }
  }
}
</style>
